"use client"
import React, {ReactNode} from "react";
import {Grid} from "@mui/material";
import useIsInRoles from "@/hooks/useIsInRoles";

export default function PSection({children, title, faIcon}: {
    children: ReactNode,
    title: string,
    faIcon: string
}) {
    const isAdminOrPhotographer = useIsInRoles(["Admin", "Photographer"]);

    return (
        <Grid
            sx = {{
        }}
            container
        >

            <Grid item xs = {12} lg = {12} >
                {children}
            </Grid >

        </Grid >
    )
}